<template>
  <div class="explain">
    <h6 class="semibold">
      {{ title }}
    </h6>
    <p v-html="description"></p>
  </div>
</template>

<script>
export default {
  name: 'ProductExplanation',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    title() {
      return {
        nominale:
          'Affidati all’esperienza di Dueruote per conoscere il reale valore della tua moto o del tuo scooter: a soli 2,99 € ottieni la Quotazione più aggiornata e affidabile sul mercato.',
        sponsor:
          'Affidati all’esperienza di Dueruote per conoscere il reale valore del veicolo: a soli 2,99 € ottieni la Quotazione più aggiornata e affidabile sul mercato.',
        storica:
          'Affidati all’esperienza di Dueruote per conoscere il reale valore del veicolo ad una specifica data nel passato: a soli 23,99€ ottieni la quotazione!',
        'ruote-classiche':
          'Affidati all’esperienza di Dueruote per conoscere il reale valore del veicolo con valenza storica o collezionistica: a soli 5,99€ ottieni la quotazione!',
      }[this.type];
    },
    description() {
      const desc = `La Quotazione Dueruote fornisce una valutazione approssimativa del valore di mercato del
                veicolo, utilizzando analisi statistiche e rilevazioni di mercato per offrire un valore
      aggiornato. <br />
      Puoi ottenere un certificato, utile per determinare il valore per vendere, acquistare e
      assicurare il veicolo selezionato. <br />
      L’attestato comprende: la quotazione per vendere, che considera le caratteristiche del veicolo
      per massimizzarne il valore; per comprare, che tiene conto delle caratteristiche principali
      del veicolo e offre consigli utili agli acquirenti; ed infine, per assicurare, <br />
      che fornisce un valore di confronto per il rinnovo della polizza incendio e furto. Questo
      valore è utilizzato dalle assicurazioni per calcolare il premio.`;
      return {
        nominale: desc,
        sponsor: desc,
        storica:
          'La Quotazione Storica fornisce una valutazione utile per richiedere un risarcimento danni o furto occorsi in periodi precedenti. Le Quotazioni sono utilizzate in diversi contesti e si adattano alle esigenze specifiche, come quelle delle assicurazioni, trattative commerciali, e permute.',
        'ruote-classiche':
          'La Quotazione Ruote Classiche consente di ottenere un certificato che contiene la valutazione di un veicolo con significato storico o collezionistico, fornendo una stima approssimativa del suo valore di mercato tramite l’utilizzo di statistiche e rilevazioni di mercato per garantire un valore aggiornato. Puoi ottenere un certificato che ti aiuta a valutare il valore del veicolo in base a criteri specifici e dettagliati, considerando il suo stato di conservazione, integrità, originalità, presenza di danni alla carrozzeria o condizioni di relitto.',
      }[this.type];
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/ProductExplanation.vue